import { Kommune } from '../../../models';
import { client } from '../../client';
import RequestService from '../requestService';

export default class KommuneService extends RequestService<Kommune, 'kommune'>
{
    hentKommuneForKommuneNr = async (kommuneNr : string) => client.get<Kommune>(`${this.serviceName}/${encodeURIComponent(kommuneNr)}/hentKommuneForKommuneNr`);
}